import React, { useMemo } from 'react';
import { _T } from "../../../../../base-react/src/Localization";
import { hooks, models } from '@vote4dance/judging-sdk';
import { Badge, Typography } from 'antd';
import { NavLink } from 'react-router-dom';
var Stream = hooks.streams.Stream;
var CafeCompetitionOrdersSource = models.cafe.CafeCompetitionOrdersSource;
import { OrderStatus } from '@vote4dance/judging-schema';
const { Text } = Typography;
export const useCafeNavMenuItemState = (props) => {
    const { event_id } = props;
    const [orders] = Stream(event_id ? CafeCompetitionOrdersSource(event_id) : undefined);
    const activeOrders = useMemo(() => {
        return orders ? orders.filter(order => order.order_status === OrderStatus.Pending).length : 0;
    }, [orders]);
    const label = activeOrders > 0 ? (React.createElement(NavLink, { to: "cafe" },
        React.createElement(Badge, { count: activeOrders, offset: [25, 10] },
            React.createElement(Text, { strong: true }, _T('cafe.title'))))) : (React.createElement(NavLink, { to: "cafe" }, _T('cafe.title')));
    return { label, activeOrders };
};
export const CafeNavMenuItem = (props) => {
    const { label } = useCafeNavMenuItemState(props);
    return React.createElement(React.Fragment, null, label);
};
